import * as et from "../application/EventTypes";

// Add here common viewer interactions.
// Some basic examples are object selection sync, camera sync and so on...

// Sync selected objects between viewers.
var onSelectionChanged = {
  eventName: et.AGGREGATE_SELECTION_CHANGED_EVENT,
  cb: function cb(sourceViewer, targetViewer, event) {
    var curModelsSelSet = sourceViewer.getAggregateSelection();

    if (targetViewer.impl.model) {
      if (curModelsSelSet.length > 0) {
        for (var i = 0; i < curModelsSelSet.length; i++) {
          var curModelSelSet = curModelsSelSet[i];
          var selectedModel = curModelSelSet.model;
          var curSelSet = curModelSelSet.selection;

          for (var j = 0; j < targetViewer.impl.modelQueue().getModels().length; j++) {
            var modeltargetViewer = targetViewer.impl.modelQueue().getModels()[j];
            if (modeltargetViewer && modeltargetViewer.getDocumentNode() && selectedModel.getDocumentNode() &&
            modeltargetViewer.getDocumentNode().originModel === selectedModel.getDocumentNode().originModel) {

              if (targetViewer.impl.is2d) {
                targetViewer.select(curSelSet, modeltargetViewer);
              } else {
                targetViewer.showAll();
                targetViewer.select(curSelSet, modeltargetViewer);
                targetViewer.isolate(curSelSet, modeltargetViewer);
              }

              targetViewer.fitToView(curSelSet);
            } else if (!targetViewer.impl.is2d && modeltargetViewer.visibilityManager) {
              // hide all objects in the other models
              modeltargetViewer.visibilityManager.setAllVisibility(false);
            }
          }
        }
      } else {
        targetViewer.clearSelection();
        if (!targetViewer.impl.is2d) {
          targetViewer.showAll();
        }
      }
    }
  } };


export var CrossViewerInteractionCommon = {
  onSelectionChanged: onSelectionChanged };